module.exports = __webpack_public_path__ + "static/media/romance_red.b9cb01ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/romance_red.png
// module id = 849
// module chunks = 0